
<!-- event Head -->
<div
  class="event-header"
  style="background-image: url(assets/image/Group-1895.png)"
>
  <div class="event-heading">
    <div class="event-head">
      <h3>SHIPMENT DETAILS</h3>
    </div>
  </div>
</div>

<div class="container">
    <div style="margin-top: 2rem;">
        <h2>SHIPMENT</h2>
    </div>
    <div class="" style="margin-top:2rem;margin-bottom: 3rem;">
        <table class="table table-bordered">
            <thead>
              <tr>
                <th>NAME</th>
                <th>PRICE</th>
                <th>SHIPMENT</th>
                <th>STATUS</th>
               
              </tr>
            </thead>
            <tbody>
                <ng-template ngFor let-usplan [ngForOf]="data">

                   

                    
              <tr>
                <td> {{usplan.placename}}</td>
                <td> $ {{usplan.productprice}}</td>
                <td>{{usplan.placename}} </td>
                <td>{{usplan.status}}</td>
               
              </tr>
            </ng-template>
            
            </tbody>
          </table>
    </div>
</div>
